// @flow
import styled from 'styled-components';

const Logo = styled.img`
max-height: 50px;
`;

export default Logo;



// WEBPACK FOOTER //
// ./src/common/components/Logo.js